import $api from "@/frontend/shared/api/axios";
import { TGetAnnotationsData } from "../types/types";

export async function patchAnnotation({ id, content }: { id: number; content: string }): Promise<TGetAnnotationsData> {
  const response = await $api.patch(`/companies/annotations/${id}`, {
    content
  });
  return response.data.data;
}
